"use client";
import React, { useEffect, useState } from "react";
import { FaChevronUp } from "react-icons/fa";

export const dynamic = "force-dynamic";

const LiveMessanger = () => {
    const [isVisible, setisVisible] = useState(false);
    const scrollToTop = () => {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    };
    const handleButtonClick = () => {
        scrollToTop();
    };
    const listenToScroll = () => {
        let heightToHidden = 250;
        const winScroll =
            document.body.scrollTop || document.documentElement.scrollTop;
        if (winScroll > heightToHidden) {
            setisVisible(true);
        } else {
            setisVisible(false);
        }
    };
    useEffect(() => {
        window.addEventListener("scroll", listenToScroll);
    }, []);
    return (
        <>
            {isVisible && (
                <div
                    className="right-8 fixed bottom-4 cursor-pointer flex flex-col justify-center items-center gap-0.5 group"
                    onClick={handleButtonClick}
                >
                    <FaChevronUp className="text-[#410EAD] transition-transform ease-in-out duration-300 group-hover:-translate-y-2" />
                    <span className="bg-[#410EAD] text-white font-mono font-bold text-lg rounded-full w-[50px] h-[50px] flex justify-center items-center p-3.5">
                        UP
                    </span>
                </div>
            )}
        </>
    );
};

export default LiveMessanger;
